import React, { useContext, useEffect, useState } from 'react';
import { FixedSizeList as List } from 'react-window';
import { GlobalContext } from '../../../App';
import { TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { useLocation } from 'react-router-dom';
import { mapFieldValues } from '../plagins/utility';
import useFilteredData from '../../template/tableV3/FilterFunction';
import useQueries from '../../../database/useQueries';
import { useIndexedDBSyncV2 } from '../../../database/dataLocal/indexedDBHooks';
import { useSelector } from 'react-redux';
import PaymentsManagementExample from '../../template/tableV3/PaymentsManagementExample';

const TableComponent = () => {
  const [localGraves2, setLocalGraves2] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  const [localAreaGraves2, setLocalAreaGraves2] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  // const [localRows, setLocalRows] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  // const [localPlots, setLocalPlots] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  // const [localBlocks, setLocalBlocks] = useState([]); // שמירת נתונים שהתקבלו מהשרת
  // const [localCemeteries, setLocalCemeteries] = useState([]); // שמירת נתונים שהתקבלו מהשרת

  const [loading, setLoading] = useState(true); // מצב טעינה
  const [offset, setOffset] = useState(0); // נקודת התחלה עבור הדף הנוכחי
  const [totalRecords, setTotalRecords] = useState(null); // סך כל הרשומות
  const [rowsPerPage, setRowsPerPage] = useState(25); // מספר רשומות להצגה בעמוד
  const [currentPage, setCurrentPage] = useState(1); // עמוד נוכחי
  const { searchText, setTotalWidthContainer } = useContext(TemplateContext);
  const { token, setBreadcrumbs, setTitle } = useContext(GlobalContext);

  const location = useLocation();
  const { getEntitiesByAttr, getEntityByAttr } = useQueries();

  // קבלת ערכים מהסטור
  const optionsFields = useSelector((state) => state.dataOptionsFieldsHe.data);
  const columns = useSelector((state) => state.columnsTableAreaGraves.data);

  // קבלת נתוני דאטה בייס
  const { data: localCemeteries, loading: loadingCemeteries } = useIndexedDBSyncV2('myStore', 'dataCemeteries');
  const { data: localBlocks, loading: loadingBlocks } = useIndexedDBSyncV2('myStore', 'dataBlocks');
  const { data: localPlots, loading: loadingPlots } = useIndexedDBSyncV2('myStore', 'dataPlots');
  const { data: localRows, loading: loadingRows } = useIndexedDBSyncV2('myStore', 'dataRows');
  const { data: localAreaGraves, loading: loadingAreaGraves } = useIndexedDBSyncV2('myStore', 'dataAreaGraves');
  const { data: localGraves, loading: loadingGraves } = useIndexedDBSyncV2('myStore', 'dataGraves');

  // בדיקה שאכן התקבלו כלל הנתונים מהדאטה בייס
  const isLoading = loadingCemeteries || loadingBlocks || loadingPlots || loadingRows || loadingAreaGraves || loadingGraves;

  // פונקציה לקבלת נתונים מהשרת
  const fetchDataFromServer = async (tableName, setData = () => {}, total = false) => {
    setLoading(true);
    try {
      // הגבלת `limit` ל-50 אם `rowsPerPage` גדול מ-50
      const limit = rowsPerPage > 500 ? 500 : rowsPerPage;

      const response = await fetch('http://localhost:3001/api/test/getTest4', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token: token,
          tableName: tableName,
          offset: offset,
          limit: 50000,
          orderBy: 'id', // העמודה למיון
          // orderDirection: 'DESC' // כיוון המיון: 'ASC' עבור עולה, 'DESC' עבור יורד
        })
      });

      const { data: newData, totalRecords: serverTotalRecords } = await response.json();

      // עדכון הסטייט עם נתונים שהתקבלו
      setData((prevData) => [...prevData, ...newData]);
      setOffset(offset + limit); // עדכון נקודת התחלה לטעינת הדף הבא

      // עדכון מספר הרשומות הכולל
      if (total) {
        if (totalRecords === null) setTotalRecords(serverTotalRecords);
      }

      // בדיקה אם כל הנתונים נטענו
      if (localGraves.length + newData.length >= serverTotalRecords) {
        console.log('All data has been loaded');
      }
    } catch (error) {
      console.error('Error fetching data from server:', error);
    } finally {
      setLoading(false);
    }
  };

  const defineHeaderTitle = () => {
    // בדיקה אם הכתובת מסתיימת ב-'globalSearch'
    if (location.pathname.endsWith('globalSearch')) {
      setBreadcrumbs([]);
      setTitle(`חיפוש כללי`);
    } else {
      setBreadcrumbs([{ id: 0, name: 'נסיון טעינת אחוזות קברים', url: '/component' }]);
      setTitle(`נסיון טעינת אחוזות קברים`);
    }
  };

  // טעינת נתונים ראשונית בעת עליית הקומפוננטה
  useEffect(() => {
    // גודל המסך
    setTotalWidthContainer(1500);
    // הגדרת שם לכותרת
    defineHeaderTitle();

    // טעינת הנתונים
    fetchDataFromServer('areaGraves', setLocalAreaGraves2, true);
    // fetchDataFromServer('areaGraves', setLocalAreaGraves, true);
    // fetchDataFromServer('rows', setLocalRows);
    // fetchDataFromServer('plots', setLocalPlots);
    // fetchDataFromServer('blocks', setLocalBlocks);
    // fetchDataFromServer('cemeteries', setLocalCemeteries);
  }, []);

  useEffect(() => {
    console.log('rowsPerPage: ', currentPage, rowsPerPage);

    // fetchDataFromServer('graves', setLocalGraves, true);
    // fetchDataFromServer('areaGraves', setLocalAreaGraves, true);
    // fetchDataFromServer('rows', setLocalRows);
    // fetchDataFromServer('plots', setLocalPlots);
    // fetchDataFromServer('blocks', setLocalBlocks);
    // fetchDataFromServer('cemeteries', setLocalCemeteries);
  }, [currentPage, rowsPerPage]); // קריאה מחדש כאשר עמוד או מספר הרשומות משתנה

  // שינוי מספר רשומות לעמוד ועמוד נוכחי
  const handlePageChange = (page) => setCurrentPage(page);
  const handleRowsPerPageChange = (event) => setRowsPerPage(Number(event.target.value));

  const addValuesToAreaGraves = () => {
    return localAreaGraves.map((areaGrave) => {
      const graves = getEntitiesByAttr(localGraves, 'areaGraveId', areaGrave?.gravesList);

      let aggregatedSummaries = graves.reduce(
        (acc, grave) => {
          // סיכום ערכי graveStatus
          if (grave.graveStatus === 1) acc.available += 1;
          if (grave.graveStatus === 2) acc.purchased += 1;
          if (grave.graveStatus === 3) acc.buried += 1;
          if (grave.graveStatus === 4) acc.saved += 1;
          if (grave.graveStatus || grave.graveStatus === 1) acc.graveSum += 1;

          // סיכום ערכי plotType
          if (grave.plotType === 1) acc.plotExempt += 1;
          if (grave.plotType === 2) acc.plotUnusual += 1;
          if (grave.plotType === 3) acc.plotClose += 1;

          return acc;
        },
        {
          plotClose: 0,
          plotUnusual: 0,
          plotExempt: 0,
          available: 0,
          purchased: 0,
          buried: 0,
          saved: 0,
          graveSum: 0
        }
      );

      return {
        ...areaGrave,
        ...aggregatedSummaries
      };
    });
  };

  const updatedAreaGraves = addValuesToAreaGraves().map((item) => {
    const graves = getEntitiesByAttr(localGraves, 'areaGraveId', item?.gravesList);
    const plot = getEntityByAttr(localPlots, 'unicId', item?.plotId);
    const row = getEntityByAttr(localRows, 'unicId', item?.lineId);
    const block = getEntityByAttr(localBlocks, 'unicId', plot?.blockId);
    const cemetery = getEntityByAttr(localCemeteries, 'unicId', block?.cemeteryId);

    const cemeteryId = cemetery?.cemeteryNameHe;
    const blockId = block?.blockNameHe;
    const plotId = plot?.plotNameHe;
    const lineId = row?.lineNameHe;
    const gravesCount = graves?.length;

    return {
      ...item,
      cemeteryNameHe: cemeteryId,
      blockNameHe: blockId,
      plotNameHe: plotId,
      lineNameHe: lineId,
      gravesCount: gravesCount
    };
  });

  const mappedData = mapFieldValues(updatedAreaGraves, optionsFields);

  // שימוש בפונקציה החיצונית לסינון הנתונים
  const filteredData = useFilteredData(mappedData, searchText);

  const handleRowClick = (row) => {
    console.log(row);

    // if (location.pathname.endsWith('globalSearch')) {
    //   navigate('/areaGrave'); // משנה את הניווט לנתיב '/block'
    // }
    // // לאחר מכן מפעיל את הפונקציה onClickRow עם הניווט המקורי
    // onClickRow(row, getSummaryByAreaGrave, navigate);
  };

  async function updateTableOnServer(tableName, recordsToUpdate) {
    try {
      const response = await fetch('http://localhost:3001/api/test/updateTest5', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          tableName: tableName,
          records: recordsToUpdate,
          fields: ['cemeteryNameHe', 'blockNameHe', 'plotNameHe', 'lineNameHe'],
          token
        })
        // body: JSON.stringify({ ...data, token })
      });

      if (!response.ok) {
        throw new Error(`Failed to update table: ${response.statusText}`);
      }

      const result = await response.json();
      console.log('Update result:', result);
      return result;
    } catch (error) {
      console.error('Error updating table on server:', error);
      throw error;
    }
  }

  useEffect(() => {
    if (!isLoading && !loading) {
      console.log('נגמרו כל הטעינות');

      const checkColumns = ['lineId', 'plotId'];
      const updateColumns = ['lineNameHe', 'plotNameHe'];

      // console.log(localAreaGraves);
      console.log(filteredData);

      // compareAndUpdateData(filteredData, localAreaGraves, checkColumns, updateColumns);
      updateTableOnServer('areaGraves', filteredData)
        .then((result) => console.log('Records updated successfully:', result))
        .catch((error) => console.error('Update failed:', error));
    }
  }, [isLoading, loading]);

  if (isLoading) return <>loading...</>;

  return (
    <div>
      <h1>Data from Server:</h1>
      {loading && <p>Loading...</p>}
      <PaymentsManagementExample columns={columns.filter((prop) => prop.show)} defaultRows={filteredData} searchText={filteredData} onRowSelect={handleRowClick} currentPage={currentPage} rowsPerPage={rowsPerPage} onPageChange={handlePageChange} onRowsPerPageChange={handleRowsPerPageChange} />
    </div>
  );
};

export default TableComponent;
